export default "__VITE_ASSET__cd912eb9__"